import React from 'react';
import { useRouter } from 'next/router';
import { Box, Flex, HStack, Image, Tag, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';

import config from '@config';
import { ProjectInfoDto } from '@projectTypes/Project';
import { safeParseJSON } from '@helpers/safeParseJSON';
import useIsEn from '@hooks/useIsEn';

import { ChatbotInfo } from './ChatbotInfo';
import FbShareButton from './FbShareButton';

type ChatbotDetailsProps = ProjectInfoDto & { chatUrl: string };

const ChatbotDetails: React.FC<ChatbotDetailsProps> = (props) => {
  const { name, schoolName, info, infoEn, chatUrl, finalProjectType } = props;
  const pInfo = safeParseJSON(info);
  const { t } = useTranslation('common');

  const tag =
    config.projectGoals.find((g) => g.key === pInfo[config.projectGoal]) ||
    finalProjectType?.toUpperCase();

  const winCategory = config.chatbotCategory[name];

  const isEn = useIsEn();
  const languageInfo = (isEn ? (infoEn ? infoEn : null) : null) || info;

  return (
    <VStack
      flex={1.5}
      justifyContent="center"
      alignItems="center"
      overflow="auto"
      p="30px"
      display="block"
    >
      <Flex
        justifyContent="space-between"
        flexDirection={['column-reverse', 'column-reverse', 'row']}
      >
        <VStack
          h="100px"
          w="full"
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          flexDirection="column"
          mb="30px"
        >
          {schoolName && (
            <Text
              display="block"
              fontSize="xl"
              lineHeight="normal"
              fontWeight="semibold"
            >
              {t('School name')}: {schoolName}
            </Text>
          )}
          <Text
            display="block"
            fontSize="xl"
            lineHeight="normal"
            fontWeight="semibold"
          >
            {t('Team')}: {name}
          </Text>
          {winCategory && <Tag colorScheme="yellow">{winCategory}</Tag>}
          {tag && <Tag colorScheme={tag.color || 'blue'}>{tag.label || tag}</Tag>}
          <FbShareButton chatUrl={chatUrl} />
        </VStack>

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          mr={[0, 0, '25px']}
          mb={['25px', '25px', 0]}
        >
          <Text
            fontSize="xl"
            lineHeight="normal"
            fontWeight="semibold"
            color="#605e60"
            mr="-10px"
            mb="10px"
          >
            Powered by
          </Text>
          <HStack>
            <Image src="/images/infobip-logo.png" maxW="100px" mr="10px" />
            <Image src="/images/a1logo.png" maxW="50px" mr="0px" />
          </HStack>
        </Box>
      </Flex>

      <Text fontStyle="italic">{t('Send Hi to start the conversation')}</Text>

      <ChatbotInfo info={languageInfo} />
    </VStack>
  );
};

export default ChatbotDetails;
